import { render } from "./gift-wrap-item.vue?vue&type=template&id=1b8b8ba8"
import script from "./gift-wrap-item.vue?vue&type=script&lang=js"
export * from "./gift-wrap-item.vue?vue&type=script&lang=js"

import "./gift-wrap-item.vue?vue&type=style&index=0&id=1b8b8ba8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__